// extracted by mini-css-extract-plugin
export default {"wrap":"PacksComponent_wrap__+6Ctj","btnBlock":"PacksComponent_btnBlock__xrnAq","listBlock":"PacksComponent_listBlock__YutXM"};